<style type="text/scss" lang="scss">
  @import '../../styles/vars';
</style>

<script>
  export let value = '';
  export let placeholder = '';
  export let label = '';
  export let readonly = false;
</script>

<div>
  <!-- LABEL -->
  {#if label}<label>{label}</label>{/if}
  <!-- COMPONENT -->
  <textarea
    readonly="{readonly}"
    bind:value="{value}"
    placeholder="{placeholder}"
  ></textarea>
</div>
